export default "__VITE_ASSET__C804bqv9__"